export enum RouteConstants {
  BenchmarkingInputs = 'benchmarking-inputs',
  BuildStructure = 'build-structure',
  CapitalStructure = 'capital-structure',
  CapmAssumptions = 'capm-assumptions',
  CapTable = 'cap-table',
  CostOfEquity = 'cost-of-equity',
  DashboardOpm = 'dashboard-opm',
  DashboardPwerm = 'dashboard-pwerm',
  DealThesis = 'deal-thesis',
  DiscountRateOverride = 'discount-rate-override',
  Dividends = 'dividends',
  DLOC = 'dloc',
  DLOM = 'dlom',
  EquityBridge = 'equity-bridge',
  OpmInputs = 'opm-inputs',
  ParticipationTableLegacy = 'participation-table-legacy',
  ParticipationTable = 'participation-table',
  PayoutLogic = 'payout-logic',
  Projects = 'projects',
  ProjectDetails = 'project-details',
  PwermWaterfall = 'waterfall-pwerm',
  RealWorldDistributions = 'real-world-distributions',
  SourcesAndUses = 'sources-and-uses',
  Summary = 'summary',
  TotalEquityCrossCheck = 'total-equity-cross-check',
  ValuationInputs = 'valuation-inputs',
  ValuationSummary = 'valuation-summary',
  OpmWaterfall = 'waterfall-opm',
  FirstLastSimulations = 'first-last-simulations',
  SampleWaterfall = 'sample-waterfall',
  InstrumentByIdLegacy = 'instrument-legacy/:instrumentId',
  InstrumentById = 'instrument/:instrumentId',
  PwermOpmConclusions = 'pwerm-opm-overall-conclusions',
  SponsorIRRAndHurdle = 'sponsor-irr-and-hurdle',
  SponsorIRR = 'sponsor-irr',
  IRRHurdleCalculations = 'irr-hurdle-calculations',
}
